import { useEffect } from "react";

import { useDispatch } from "react-redux";

import {
    TOGGLE_OFF_COMPARE_DROPDOWN,
    TOGGLE_ON_PERSISTENT_QUERY_BAR,
} from "app/action_types/website_analysis_action-types";
import { TouchHookBanner } from "app/common/TouchHookBanner/TouchHookBanner";

import { BannerOverlay, LockedPageContainer } from "./WebsiteContentLockedPage.styles";

export const WebsiteContentLockedPage = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch({ type: TOGGLE_ON_PERSISTENT_QUERY_BAR });
        return () => {
            dispatch({ type: TOGGLE_OFF_COMPARE_DROPDOWN });
        };
    }, [dispatch]);

    return (
        <LockedPageContainer data-automation="website-content-locked-page">
            <BannerOverlay>
                <TouchHookBanner />
            </BannerOverlay>
        </LockedPageContainer>
    );
};
